import { pick } from "../services/common/object-util";

export const teamReducer = (team, ...additionalKeys) => {
    return pick(team, "id", "teamId", ...additionalKeys);
};

export const playerReducer = (player, ...additionalKeys) => {
    return pick(player, "id", "playerId", "teamId", ...additionalKeys);
};
